var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",staticClass:"oct-menu-item-group",attrs:{"role":_vm.role}},[_c('span',{staticClass:"oct-menu-item-group__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }